<template>
  <FormContainer class="form-project" @submitForm="saveProject">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4"
        label="Nome del progetto"
        v-model="project.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputMonthPickerWidget
        class="col-sm-6 col-lg-4 col-xl-2"
        label="Mese di inizio"
        v-model="project.begin"
        :errorMsg="errorHash['begin']"
        @input="removeError('begin')"
      />

      <FormInputMonthPickerWidget
        class="col-sm-6 col-lg-4 col-xl-2"
        label="Mese di fine"
        v-model="project.end"
        :errorMsg="errorHash['end']"
        @input="removeError('end')"
      />

      <FormInputAmountWidget
        class="col-sm-6 col-lg-4 col-xl-2"
        label="Ricavo totale"
        v-model.number="project.ricavo"
        :min="0"
        :errorMsg="errorHash['ricavo']"
        @input="removeError('ricavo')"
      />

      <FormInputPercentageWidget
        class="col-sm-6 col-lg-4 col-xl-2"
        label="Aliquota IVA"
        v-model.number="project.vat"
        :errorMsg="errorHash['vat']"
        @input="removeError('vat')"
      />
    </div>

    <b-tabs class="mt-5">
      <b-tab title="Fatturazione ricavi" fill>
        <b-card>
          <FormInputPianoFatturazioneWidget
            label="Fatturazione ricavi"
            v-model="project.fatturazioni"
            :total="fatturazioniTotal"
            :scadenzarioPercentage="fatturazioniScadenzarioPercentage"
            :startMonth="project.begin"
            :firstMonth="project.end"
          />
        </b-card>
      </b-tab>
      <b-tab title="Costi del personale">
        <b-card>
          <FormInputProjectPersonnelCostsWidget
            label="Costi del personale"
            v-model="project.personnel"
            :personnel="personnel"
            :firstMonth="project.begin"
            :lastMonth="project.end"
          />
        </b-card>
      </b-tab>
      <b-tab title="Costi esterni">
        <b-card>
          <FormInputProjectExternalCostsWidget
            label="Costi esterni"
            :libraryCosts="libraryCosts"
            v-model="project.costs"
            :firstMonth="project.end"
          />
        </b-card>
      </b-tab>
      <b-tab title="Costi figurati">
        <b-card>
        <FormInputProjectImputedCostsWidget
          label="Costi figurati"
          v-model="project.imputedCosts"
          :libraryImputedCosts="libraryImputedCosts"
          :firstMonth="project.begin"
          :lastMonth="project.end"
        />
        </b-card>
      </b-tab>
      <template #tabs-end>
        <div class="end-item">
            <button class="btn btn-primary" type="submit">
              <i class="fas fa-save mr-2"></i>
              Salva progetto
            </button>
        </div>
      </template>
    </b-tabs>

  </FormContainer>
</template>

<script>
import { BTabs, BTab, BCard } from 'bootstrap-vue';
import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  data () {
    return {
      collapse: {
        fatturazioni: false,
        personnel: false,
        costs: false,
        imputedCosts: false,
      },
    };
  },
  components: {
    BTabs,
    BTab,
    BCard,
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    FormInputProjectPersonnelCostsWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputProjectPersonnelCostsWidget'),
    FormInputProjectExternalCostsWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputProjectExternalCostsWidget'),
    FormInputProjectImputedCostsWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputProjectImputedCostsWidget'),
    FormInputPianoFatturazioneWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputPianoFatturazioneWidget'),
  },
  props: {
    project: {
      type: Object,
      default: () => ({
        name: null,
        begin: null,
        end: null,
        ricavo: null,
        vat: 22,
        fatturazioni: [],
        personnel: [],
        costs: [],
        imputedCosts: [],
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    personnel: {
      type: Array,
      default: () => [],
    },
    libraryCosts: {
      type: Array,
      default: () => [],
    },
    libraryImputedCosts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fatturazioniTotal () {
      return Math.ceil(this.project?.ricavo || 0);
    },
    fatturazioniScadenzarioPercentage () {
      return this.project?.vat || 0;
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.project.name) {
        this.addError('Il nome del progetto è obbligatorio', 'name');
      }

      if (!this.project.begin) {
        this.addError('Il mese di inizio è obbligatorio', 'begin');
      }

      if (!this.project.end) {
        this.addError('Il mese di fine è obbligatorio', 'end');
      } else if (this.project.begin && this.project.end < this.project.begin) {
        this.addError('Il mese di fine deve essere successivo al mese di inizio', 'end');
      }

      if (!this.project.ricavo && this.project.ricavo !== 0) {
        this.addError('Il ricavo totale è obbligatorio', 'ricavo');
      }

      if (!this.project.vat && this.project.vat !== 0) {
        this.addError('Il campo iva è obbligatorio', 'vat');
      }

      return !this.hasErrors;
    },
    saveProject () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.project);
    },
  },
};

</script>

<style lang="scss">

.form-project {
  .end-item {
    margin-left: auto;
  }

  .col-key-actions {
    width: 70px;
    min-width: 70px;
  }

  .col-key-month {
    width: 120px;
    min-width: 120px;
  }

  .col-key-amount {
    width: 150px;
  }

  .col-key-scadenzarioTotal {
    width: 200px;
    min-width: 200px;
  }

  .col-key-hours {
    width: 150px;
  }

  .col-key-monthsHours {
    width: 350px;
  }

  .piano-control {
    margin-top: 10px;

    .section-title {
      font-size: 18px;
      line-height: 21px;
      font-weight: bold;
      margin-bottom: 28px;
    }

    .btn {
      padding: 7px 15px;
      font-size: 15px;
      line-height: 18px;
    }

    .counter {
      font-size: 14px;
      line-height: 16px;
      font-weight: bold;
      text-transform: uppercase;
      color: #494E50;

      .invoiced-count {
        margin-left: 8px;
        vertical-align: text-bottom;
      }
    }

    .alert {
      margin-top: 5px;
    }

    .awl-table {
      .table-primary, .table-primary > th, .table-primary > td {
        background: rgba(73, 78, 80, 0.06);
      }
      .table-primary th, .table-primary td, .table-primary thead th, .table-primary tbody + tbody {
        border: none;
      }

      tbody tr:nth-of-type(odd) td {
        background: white;
      }

      .table {
        margin-bottom: 0;
      }
    }

    .col-key-scadenzario {
      padding-right: 0;

      .awl-table {
        .table {
          tr {
            th, td {
              border-top: none;
              background: rgba(73, 78, 80, 0.04);
              padding: 6px !important;
            }

            td:first-child {
              border-top-left-radius: 3px;
              border-bottom-left-radius: 3px;
            }

            td:last-child {
              border-top-right-radius: 3px;
              border-bottom-right-radius: 3px;
            }
          }
        }
      }
    }
  }
}

</style>
